import { render, staticRenderFns } from "./EmptyResultsPhrases.vue?vue&type=template&id=4c48510c"
import script from "./EmptyResultsPhrases.vue?vue&type=script&lang=ts"
export * from "./EmptyResultsPhrases.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports